module.exports = __webpack_public_path__ + "293fa69710735df63af68ebe55adea79.svg";